// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchPost } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableApproval } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { maxPageGlobal } from "../../../assets/config";
import { toast } from "react-toastify";
import { downloadExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const MasterApprovalv2 = ({}) => {
  let initialState = {
    FrancoID: "",
    FrancoName: "",
    Status: 1,
  };
  const validations = [
    ({ FrancoName }) =>
      isRequired(FrancoName) || { FrancoName: "Nama Franco wajib diisi" },
    ({ FrancoName }) =>
      isRequired(FrancoName) || { FrancoName: "Status wajib diisi" },
  ];
  const [buttonTouched, setButtonTouched] = useState(false);

  const {
    changed,
    values,
    isValid,
    touched,
    clearHandler,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    editHandler,
  } = useForm(initialState, validations);
  const [search, setSearch] = useState("");
  const [filterMenu, setFilterMenu] = useState("");
  const [dataUpkeep, setdataUpkeep] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [detailData, setDetailData] = useState([]);

  const [maxPage, setMaxPage] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "",
  });
  const mutationData = useMutation((param) =>
    fetchPost("Master/Approval/getAll", param)
  );
  const mutation = useMutation((formData) =>
    fetchPost("Master/Approval/Insert", formData)
  );
  const mutationEdit = useMutation((formData) =>
    fetchPost("Master/Approval/update", formData)
  );

  const [showModalEdit, setShowModalEdit] = useState(false);

  useEffect(() => {
    toast.info("Loading table!", {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });

    mutationData.mutate(param, {
      onSuccess: async (data, context) => {
        let calc = data?.count - 1;
        if (calc === 0) {
          calc = 1;
        }

        if (calc % count === 0) {
          calc = calc + 1;
        }

        let tempMaxPage = data.data ? Math.ceil(calc / count) : 1;
        setMaxPage(tempMaxPage);
      },
    });
  }, [param]);

  const header = [
    { name: "Menu", key: "Group", modifiers: "Text" },
    { name: "Bagian", key: "BagianLabel", modifiers: "Text" },
    { name: "Edit", key: "Edit", modifiers: "Button" },
  ];

  const inputBuilder = [
    {
      type: "Menu",
      name: "Group",
      title: "Menu",
      handler: customHandler,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "Bagianv2",
      name: "Bagian",
      title: "Bagian",
      handler: customHandler,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
  ];

  const filterData = (event) => {
    const filtered = mutationData.data.filter(({ NamaKaryawan }) =>
      NamaKaryawan.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setdataUpkeep(filtered);
  };

  const ModalOpener = (detail) => {
    setShowModal(!showModal);
    setDetailData([]);
    setDetail(detail);
  };

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    setParam({
      start: newStart,
      count: count,
      search: "",
    });
  }

  function handleUpdateCount(newCount) {
    let calc = count - 1;
    if (calc === 0) {
      calc = 1;
    }
    setParam({
      start: parseInt(newCount === "-1" ? 0 : start),
      count: parseInt(newCount === "-1" ? count : newCount),
      search: search,
    });
    setPage(newCount === "-1" ? 0 : start);
    setStart(newCount === "-1" ? count : newCount);
    setSearch(search);
    setPage(1);
    setCount(newCount === "-1" ? count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function handleModal(value) {
    setShowModal(true);
    setShowModalEdit(true);
    setDetailData(value.Detail);
    editHandler(value);
  }

  const customHandlerApproval = (value, names, id) => {
    let newValues = detailData;
    newValues[id]["Nik"] = value;
    newValues[id]["Urutan"] = (id + 1).toString();
    setDetailData([...newValues]);
    editHandler(values);
  };
  const customHandlerApprovalAdd = () => {
    let newValues = detailData;
    const id = detailData.length;
    newValues[id] = {
      Urutan: id,
      Nik: "",
    };

    setDetailData([...newValues]);
  };

  const customHandlerApprovalDelete = (id) => {
    let newValues = detailData;
    newValues.splice(id, 1);
    setDetailData([...newValues]);
  };

  const approverNames = (row) =>
    (row.Detail || [])
      .map((d) => d.Nama)
      .filter(Boolean)
      .join(", ");

  const menuLabel = (row) =>
    row.Group === "PriceComparationBesar"
      ? "PriceComparation > 10jt"
      : row.Group || "";

  const allRows = mutationData.data?.data || [];

  // Daftar Menu unik untuk dropdown filter
  const menuOptions = [...new Set(allRows.map((r) => r.Group).filter(Boolean))].sort();

  // Filter (dropdown Menu) + Search (teks) — keduanya client-side, case-insensitive
  const filteredRows = allRows.filter((row) => {
    if (filterMenu && row.Group !== filterMenu) return false;
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return (
      (row.Group || "").toLowerCase().includes(q) ||
      (row.NamaBagian || "").toLowerCase().includes(q) ||
      approverNames(row).toLowerCase().includes(q)
    );
  });

  // Lembur/Cuti/Sakit: baris Bagian "-" (Tanpa Bagian) = VERIFIKATOR TETAP yang dijalankan
  // setelah atasan dari Struktur Organisasi (backend approval_struktur.go). Field tampilan
  // terpisah agar nilai "Bagian" untuk Edit tetap utuh.
  const labelBagian = (row) =>
    ["Lembur", "Cuti", "Sakit", "PerjalananDinas"].includes(row.Group) && (row.Bagian === "-" || !row.Bagian)
      ? "Verifikator (semua bagian, setelah atasan Struktur Organisasi)"
      : row.Bagian;
  const tableData = mutationData.data
    ? {
        ...mutationData.data,
        data: filteredRows.map((r) => ({ ...r, BagianLabel: labelBagian(r) })),
        count: filteredRows.length,
      }
    : mutationData.data;

  const exportHeaders = ["Menu", "Bagian", "Pemberi Approval"];

  const buildExportRows = (rows) =>
    rows.map((row) => [
      menuLabel(row),
      ["Lembur", "Cuti", "Sakit", "PerjalananDinas"].includes(row.Group) && (row.Bagian === "-" || !row.Bagian)
        ? "Verifikator (semua bagian)"
        : row.NamaBagian || "",
      approverNames(row),
    ]);

  const handleDownloadExcel = () => {
    if (filteredRows.length === 0) {
      toast.info("Tidak ada data untuk diexport", { position: "top-center", autoClose: 1500 });
      return;
    }
    downloadExcel({
      fileName: "Master_Approval",
      sheet: "Approval",
      tablePayload: { header: exportHeaders, body: buildExportRows(filteredRows) },
    });
  };

  const handleDownloadPDF = () => {
    if (filteredRows.length === 0) {
      toast.info("Tidak ada data untuk diexport", { position: "top-center", autoClose: 1500 });
      return;
    }
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.text("Master Approval", 14, 15);
    autoTable(doc, {
      startY: 22,
      head: [exportHeaders],
      body: buildExportRows(filteredRows),
      styles: { fontSize: 8 },
      headStyles: { fillColor: [41, 128, 185] },
    });
    doc.save("Master_Approval.pdf");
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between px-4 pt-4">
                <div className="flex flex-col gap-2 sm:flex-row sm:items-center w-full">
                  <div className="inline-block relative w-full sm:w-52">
                    <select
                      value={filterMenu}
                      onChange={(e) => setFilterMenu(e.target.value)}
                      className="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-800 px-3 py-2 pr-8 rounded shadow-sm text-sm leading-tight focus:outline-none focus:border-main-100"
                    >
                      <option value="">Semua Menu</option>
                      {menuOptions.map((m) => (
                        <option key={m} value={m}>
                          {m}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                  <input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Cari menu / bagian / approver..."
                    className="block w-full sm:w-72 border border-gray-300 rounded py-2 px-3 text-sm shadow-sm focus:outline-none focus:border-main-100"
                  />
                </div>
                <div className="flex flex-row gap-2">
                  <button
                    onClick={handleDownloadExcel}
                    className="flex flex-row items-center justify-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-sm whitespace-nowrap"
                  >
                    Download Excel
                  </button>
                  <button
                    onClick={handleDownloadPDF}
                    className="flex flex-row items-center justify-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-sm whitespace-nowrap"
                  >
                    Download PDF
                  </button>
                </div>
              </div>
              <div className="flex flex-col items-center content-center ">
                <DynamicTableApproval
                  data={tableData}
                  header={header}
                  menuController={filterData}
                  Master={true}
                  currentPage={page}
                  maxPage={maxPage}
                  name={"Franco"}
                  OnClick={ModalOpener}
                  updateCount={handleUpdateCount}
                  count={count}
                  updatePage={handleUpdatePage}
                  modal={handleModal}
                  editor={handleModal}
                />
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);

                  clearHandler();
                }}
              >
                {showModalEdit ? "Edit Data" : "Tambah Data"}
              </ModalHeader>
              <ModalBody>
                <form className="w-full " onSubmit={submitHandler}>
                  {inputBuilder.map(
                    (
                      {
                        type,
                        name,
                        title,
                        handler,
                        modifiers,
                        size,
                        required,
                        disabled,
                        edit,
                      },
                      id
                    ) => {
                      if (!edit || showModalEdit) {
                        return (
                          <HrdInputGenerator
                            type={type}
                            value={values}
                            name={name}
                            title={title}
                            onChange={handler}
                            touched={touched}
                            buttonTouched={buttonTouched}
                            modifiers={modifiers}
                            size={size}
                            required={required}
                            errors={errors}
                            disabled={disabled}
                          />
                        );
                      }
                    }
                  )}

                  <div className={"full"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      List approval
                    </label>
                    <a
                      onClick={(e) => {
                        customHandlerApprovalAdd();
                      }}
                      className={
                        "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                      }
                    >
                      {"Tambah"}
                    </a>
                  </div>
                  <br />
                  <ul className="w-52 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg ">
                    {detailData &&
                      detailData.map((detail, id) => (
                        <div className={"full"}>
                          <li
                            className="w-full px-4 py-2 rounded-b-lg"
                            key={"LI" + id}
                          >
                            <HrdInputGenerator
                              keys={"inputgen" + id}
                              type={"karyawanApproval"}
                              value={detail}
                              name={"Nik"}
                              title={"Nik"}
                              idApproval={id}
                              onChange={customHandlerApproval}
                              size={"full"}
                              required={true}
                              errors={errors}
                              disabled={false}
                              customHandlerApprovalDelete={
                                customHandlerApprovalDelete
                              }
                            />
                          </li>
                        </div>
                      ))}
                  </ul>
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    clearHandler();
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                <Button
                  color={isValid || !isValid ? "green" : "blueGray"}
                  disabled={mutation.isLoading}
                  onClick={() => {
                    if (!isValid && changed) {
                      setButtonTouched(true);
                    }
                    let tempIsValid = isValid;
                    if (!isValid) {
                    }
                    if (showModalEdit) {
                      let newValues = values;
                      newValues.Detail = detailData;
                      mutationEdit.mutate(newValues, {
                        onSuccess: () => {
                          setShowModal(false);
                          setShowModalEdit(false);

                          toast.info("Loading table!", {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            theme: "light",
                          });

                          mutationData.mutate(param);
                          clearHandler();
                        },
                      });
                    } else {
                      let newValues = values;
                      newValues.Detail = detailData;

                      mutation.mutate(values, {
                        onSuccess: () => {
                          setShowModal(false);
                          setShowModalEdit(false);

                          toast.info("Loading table!", {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            theme: "light",
                          });

                          mutationData.mutate(param);
                          clearHandler();
                        },
                      });
                    }
                  }}
                  ripple={isValid ? "light" : ""}
                >
                  {mutation.isLoading ? (
                    <>
                      <svg
                        aria-hidden="true"
                        role="status"
                        className="inline mr-3 w-4 h-4 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="current
                                       Color"
                        />
                      </svg>
                      Loading
                    </>
                  ) : (
                    "Submit"
                  )}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterApprovalv2;
